export default __webpack_public_path__ + "static/media/SourceSerifPro-ExtraLight.8d03a055.ttf";